<template>
  <div id="sketch-list">
    <v-row
      no-gutters
      class="white pa-3 elevation-4">
      <v-col cols="12">
        <img-popup-preview
          v-model="imgPopup"
          :img-src="currentPreviewImg" />
        <header-tool-bar
          :value="filter"
          state="sketch"
          @input="filterUpdated($event)"
          @search-clicked="filterUpdated($event)" />
      </v-col>
    </v-row>
    <v-row
      no-gutters
      class="white pa-3 mt-2">
      <v-col
        cols="12"
        class="mb-2 d-flex">
        <h1 class="title">
          Sketch
        </h1>
        <v-spacer></v-spacer>
        <v-btn
          class="ml-2"
          color="success"
          to="/prototype/sketch/create">
          CREATE
        </v-btn>
      </v-col>
      <v-col
        cols="7"
        class="pa-2 table-wrap">
        <v-data-table
          v-model="sketchSelected"
          :headers="sketchHeader"
          :items="prototypes"
          :loading="tableLoading"
          :options.sync="options"
          :items-per-page="options.itemsPerPage"
          :server-items-length="itemsLength"
          item-key="id"
          dense
          show-select
          hide-default-footer
          @update:sort-by="optionsUpdated()"
          @update:sort-desc="optionsUpdated()">
          <template #body="{ headers, items, isSelected, select }">
            <table-body-prototype
              :items="items"
              :headers="headers"
              :is-selected="isSelected"
              :select="select"
              :search-text="filter.search"
              :prototype-selected-id="selectedId"
              blank-item="-"
              @click:row="expandSketch($event)">
              <template #[`item.sketch.collectionId`]="{ value }">
                {{ getCollectionName(value) }}
              </template>
              <template #[`item.createdAt`]="{ value }">
                {{ getDate(value) }}
              </template>
              <template #[`item.diffDays`]="{ item }">
                {{ getDiff(item) }}
              </template>
              <template #[`item.action`]="{ item }">
                <v-menu offset-y>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      x-small
                      v-on="on">
                      <v-icon small>
                        mdi-dots-horizontal
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item
                      link
                      :to="`/prototype/sketch/edit/${item.id}`">
                      <v-list-item-title>EDIT</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      link
                      @click="tryToDeleteSketch(item.id)">
                      <v-list-item-title>DELETE</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </table-body-prototype>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="5 pl-4">
        <div
          v-if="prototypeSelected"
          class="detail-wrap pa-0">
          <detail-box
            :prototype-selected="prototypeSelected"
            @img-click="imgPreview($event)"
            @create-order-click="createOrder(prototypeSelected)" />
        </div>
      </v-col>
      <v-col
        cols="7"
        class="d-flex justify-center mt-2">
        <v-btn
          :disabled="isDisableBtn"
          outlined
          class="mx-2"
          @click="createManyOrders()">
          ส่งใบงาน ({{ sketchSelected.length }})
        </v-btn>
        <v-btn
          :disabled="isDisableBtn"
          outlined
          class="mx-2"
          @click="exportPdf()">
          Export PDF
        </v-btn>
        <!-- <v-btn
          :disabled="isDisableBtn"
          outlined
          class="mx-2"
          @click="exportCsv()">
          Export CSV
        </v-btn> -->
      </v-col>
      <v-col
        cols="5"
        class="mt-2">
        <v-pagination
          v-model="options.page"
          :total-visible="5"
          :length="pageCount"
          :disabled="tableLoading"
          color="secondary"
          @input="pageUpdated($event)" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { ExportToCsv } from 'export-to-csv'
import SketchProvider from '@/resources/SketchProvider'
import PrototypeOrderProvider from '@/resources/PrototypeOrderProvider'
import ProductAttributeProvider from '@/resources/ProductAttributeProvider'
import HeaderToolBar from '../components/HeaderToolBar.vue'
import ImgPopupPreview from '../components/ImgModalPreview.vue'
import TableBodyPrototype from '../components/TableBodyPrototype.vue'
import DetailBox from '../components/DetailBox.vue'
import FabricsProvider from '@/resources/FabricsProvider'

const SketchService = new SketchProvider()
const PrototypeOrderService = new PrototypeOrderProvider()
const ProductAttributeService = new ProductAttributeProvider()

export default {
  components: {
    HeaderToolBar,
    ImgPopupPreview,
    TableBodyPrototype,
    DetailBox
  },
  data () {
    return {
      fabricService: new FabricsProvider(),
      imgPopup: false,
      currentPreviewImg: '',
      options: {
        sortBy: ['createdAt'],
        sortDesc: [true],
        page: 1,
        itemsPerPage: 15
      },
      pageCount: 0,
      itemsLength: 0,
      currentPage: 1,
      prototypeSelected: null,
      sketchSelected: [],
      sketchHeader: [
        {
          text: 'Sketch ID',
          sortable: false,
          align: 'center',
          value: 'sketch.sketchId'
        },
        {
          text: 'Collection',
          sortable: false,
          align: 'center',
          value: 'sketch.collectionId'
        },
        {
          text: 'Designer',
          sortable: false,
          align: 'center',
          value: 'sketch.designer.name'
        },
        {
          text: 'Merchandiser',
          sortable: false,
          align: 'center',
          value: 'sketch.merchandiser.name'
        },
        {
          text: 'Factory Name',
          sortable: false,
          align: 'center',
          value: 'sketch.factory.name'
        },
        {
          text: 'Classification',
          sortable: false,
          align: 'center',
          value: 'sketch.classification'
        },
        {
          text: 'Date',
          sortable: false,
          align: 'center',
          value: 'createdAt'
        },
        {
          text: 'Days',
          sortable: false,
          align: 'center',
          value: 'diffDays'
        },
        {
          text: '',
          sortable: false,
          align: 'center',
          value: 'action'
        }
      ],
      prototypes: [],
      tableLoading: false,
      searchTimeout: null,
      collections: []
    }
  },
  computed: {
    ...mapGetters({
      prototypesState: 'Prototypes/prototypes'
    }),
    isDisableBtn () {
      return this.sketchSelected.length === 0
    },
    filter () {
      const { query } = this.$route
      this.setPage(query?.page || 1)
      return {
        search: query?.search || '',
        designer: query?.designer || '',
        merchandiser: query?.merchandiser || '',
        graphic: query?.graphic || '',
        stylist: query?.stylist || '',
        factory: query?.factory || '',
        category: query?.category || '',
        collectionId: query?.collectionId || '',
        itemsPerPage: query?.itemsPerPage || 25,
        state: 'sketch'
      }
    },
    selectedId () {
      return this.prototypeSelected?.id || null
    }
  },
  created () {
    this.getSketches()
    this.getCollections()
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Components/setSnackbar',
      setModal: 'Components/setModal',
      setLoading: 'Components/setLoading',
      setPrototypes: 'Prototypes/setPrototypes'
    }),
    isNewSchema (item) {
      return 'fabrics' in item.sketch
    },
    setPage (page) {
      this.options.page = Number(page)
    },
    async getCollections () {
      try {
        const { data } = await ProductAttributeService.getAllProductAttribute()
        this.collections = data.collections
          ? data.collections.map((item) => ({ id: item.id, name: item.name }))
          : []
      } catch (error) {
        console.error('getCollections', error)
      }
    },
    getCollectionName (collectionId) {
      return this.collections.find((c) => c.id === collectionId)?.name || '-'
    },
    getDate (value) {
      if (value !== '-') {
        return this.$dayjs(value).format('DD/MM/YYYY')
      }
      return value
    },
    getDiff (item) {
      if (item.sketch?.createdAt) {
        return this.$dayjs().diff(this.$dayjs(item.sketch.createdAt), 'day') + 1
      }
      return '-'
    },
    async expandSketch ({ item }) {
      this.prototypeSelected = { ...item }
    },
    filterUpdated (filters) {
      this.options.itemsPerPage = filters.itemsPerPage
      this.getDataFromFilters({ ...filters, page: 1 })
    },
    pageUpdated (page) {
      this.getDataFromFilters({ ...this.filter, page })
    },
    getDataFromFilters (filters) {
      this.$router.push({
        name: this.$route.name,
        query: { ...filters }
      }).catch(() => {})
      this.getSketches(this.options, filters)
    },
    optionsUpdated () {
      this.getSketches()
    },
    async getSketches (options = this.options, filter = this.filter) {
      try {
        this.tableLoading = true
        const { data } = await SketchService.getManySketches({ ...options, ...filter })
        this.itemsLength = data.total
        this.pageCount = data.pages
        this.prototypes = data.results
        if (this.prototypes.length > 0) {
          this.prototypeSelected = this.prototypes[0]
        }
      } catch (error) {
        this.setSnackbar({
          value: true,
          message: `${error.code}: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.tableLoading = false
      }
    },
    async searchClicked (filter) {
      this.filter = filter
      this.getSketches()
    },
    tryToDeleteSketch (id) {
      this.setModal({
        value: true,
        title: 'DeleteSketch',
        message: 'Do you want to delete this sketch ?',
        confirmText: 'Delete',
        confirmType: 'error',
        cancelType: '',
        cancelText: 'Cancel',
        onConfirm: () => this.deleteSketch(id)
      })
    },
    async deleteSketch (id) {
      try {
        this.tableLoading = true

        await SketchService.deleteSketch(id)
        this.setSnackbar({
          value: true,
          message: 'Sketch has been deleted.',
          type: 'success'
        })
        this.getSketches()
      } catch (error) {
        this.setSnackbar({
          value: true,
          message: `${error.code}: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.tableLoading = false
      }
    },
    async createOrder (sketchSelected) {
      try {
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'LOADING...'
        })

        const readySketches = [sketchSelected].filter(
          (sketch) => this.checkFieldSketch(sketch)
        )

        const notReadySketches = [sketchSelected].filter(
          (sketch) => !this.checkFieldSketch(sketch)
        )

        if (notReadySketches.length > 0) {
          const sketchIdsNotReady = notReadySketches
            .map((s) => s.sketch?.sketchId)
            .join(', ')

          this.setSnackbar({
            value: true,
            message: `${sketchIdsNotReady} ระบุข้อมูลไม่ครบถ้วน`,
            type: 'error'
          })
        }

        if (readySketches.length > 0) {
          await PrototypeOrderService.createOrder({ ids: [sketchSelected.id] })

          this.setSnackbar({
            value: true,
            message: 'Sketch has been changed to order state.',
            type: 'success'
          })

          this.$router.push({ name: 'OrderFormList' })
        }
      } catch (error) {
        this.setSnackbar({
          value: true,
          message: `${error.code}: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.setLoading({ active: false })
      }
    },
    checkFieldSketch ({ sketch }) {
      const requiredFields = [
        'category',
        'brand',
        'collectionId',
        'designer',
        'graphic',
        'marketing',
        'merchandiser',
        'producer',
        'stylist',
        'visualMerchandiser'
      ]

      return requiredFields.every((field) => Boolean(sketch[field]))
    },
    async createManyOrders () {
      try {
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'LOADING...'
        })

        const readySketches = this.sketchSelected.filter(
          (sketch) => this.checkFieldSketch(sketch)
        )

        const notReadySketches = this.sketchSelected.filter(
          (sketch) => !this.checkFieldSketch(sketch)
        )

        if (readySketches) {
          await Promise.all(
            readySketches.map((sketch) => PrototypeOrderService.createOrder({ ids: [sketch.id] }))
          )
          this.getSketches()
        }

        if (notReadySketches.length > 0) {
          const sketchIdsNotReady = notReadySketches
            .map((s) => s.sketch?.sketchId)
            .join(', ')

          this.setSnackbar({
            value: true,
            message: `${sketchIdsNotReady} ระบุข้อมูลไม่ครบถ้วน`,
            type: 'error'
          })
        } else {
          const ids = this.sketchSelected.map((sketch) => sketch.id)

          await PrototypeOrderService.createOrder({ ids })

          this.setSnackbar({
            value: true,
            message: 'Sketches has been changed to orders',
            type: 'success'
          })

          this.$router.push({ name: 'OrderFormList' })
        }
      } catch (error) {
        this.setSnackbar({
          value: true,
          message: `${error.code}: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.setLoading({ active: false })
      }
    },
    imgPreview (src) {
      this.currentPreviewImg = src
      this.imgPopup = true
    },
    exportPdf () {
      this.setPrototypes(this.sketchSelected)
      window.open(this.$router.resolve({ name: 'ExportSketch' }).href, '_blank')
    },
    exportCsv () {
      if (this.sketchSelected.length > 0) {
        const preExport = this.sketchSelected.map((sketch) => ({
          'Sketch ID': sketch?.sketchId || '-',
          'Category': sketch?.category?.name || '-',
          'Collection': sketch?.collectionName || '-',
          'Designer': sketch?.designer?.name || '-',
          'Merchandiser': sketch?.merchandiser?.name || '-',
          'Factory': sketch?.factory?.name || '-',
          'Classification': sketch?.classification || '-',
          'Date': this.$dayjs(sketch?.createdAt).format('YYYY-MM-DD') || '-',
          'Note': sketch?.note || '-',
          'Sizing Detail': this.preExportSizingDetail(sketch?.sizeDetail)
        }))

        const options = {
          filename: `SKETCHES(${this.$dayjs().format('YYYY-MM-DDTHH-mm')})`,
          showLabels: true,
          useKeysAsHeaders: true
        }
        const csvExporter = new ExportToCsv(options)
        csvExporter.generateCsv(preExport)
      }
    },
    preExportSizingDetail (sizeDetail) {
      const result = sizeDetail.map((detail) => (
        detail.options.map((option) => `${detail.size}(${option.key})=${option.value}`)
      ))

      return result.toString()
    }
  }
}
</script>

<style scope>

.table-wrap {
  padding: 12px;
  border: 1px solid rgba(0, 0, 0, 0.42);
  border-radius: 5px;
  height: calc(100vh - 320px);
  overflow-y: scroll;
}

.detail-wrap {
  padding: 12px;
  border: 1px solid rgba(0, 0, 0, 0.42);
  border-radius: 5px;
  height: calc(100vh - 320px);
  overflow-y: scroll;
}

.action-col {
  color: rgb(83, 83, 240);
  cursor: pointer;
}

.field-label {
  font-weight: bold;
}

</style>
